import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("blog_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

// ----- Public -----
export const fetchPosts = async () => (await api.get("/posts")).data;
export const fetchFeaturedPosts = async () =>
  (await api.get("/posts/featured")).data;
export const fetchPost = async (slug) => (await api.get(`/posts/${slug}`)).data;
export const fetchPreviewPost = async (token) =>
  (await api.get(`/posts/preview/${token}`)).data;
export const subscribe = async (email, sourceSlug = "") =>
  (
    await api.post("/subscribe", {
      email,
      ...(sourceSlug ? { source_slug: sourceSlug } : {}),
    })
  ).data;
export const fetchSettings = async () => (await api.get("/settings")).data;

// ----- Auth -----
export const login = async (email, password) =>
  (await api.post("/auth/login", { email, password })).data;
export const me = async () => (await api.get("/auth/me")).data;

// ----- Admin -----
export const adminListPosts = async () =>
  (await api.get("/admin/posts")).data;
export const adminCreatePost = async (payload) =>
  (await api.post("/admin/posts", payload)).data;
export const adminUpdatePost = async (id, payload) =>
  (await api.put(`/admin/posts/${id}`, payload)).data;
export const adminDeletePost = async (id) =>
  (await api.delete(`/admin/posts/${id}`)).data;
export const adminReorderPosts = async (orderedIds) =>
  (await api.put("/admin/posts/reorder", { order: orderedIds })).data;
export const adminListSubscribers = async () =>
  (await api.get("/admin/subscribers")).data;
export const adminAddSubscriber = async (email) =>
  (await api.post("/admin/subscribers", { email })).data;
export const adminUpdateSubscriber = async (id, email) =>
  (await api.put(`/admin/subscribers/${id}`, { email })).data;
export const adminDeleteSubscriber = async (id) =>
  (await api.delete(`/admin/subscribers/${id}`)).data;

export const adminUploadImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/admin/images", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const adminUpdateSettings = async (payload) =>
  (await api.put("/admin/settings", payload)).data;

// Resolve relative image URLs (e.g. /api/images/<id>) to absolute backend URLs
export const resolveImageUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};

// Build the shareable URL for a post — a clean domain URL that Netlify
// proxies to the backend /api/share/:slug OG endpoint at request time.
// LinkedIn / X / iMessage crawlers see your real domain (trusted) and pick
// up the server-rendered OG tags. Humans get instant redirect to the SPA.
export const buildShareUrl = (slug) => {
  if (typeof window === "undefined") return "";
  return `${window.location.origin}/p/${encodeURIComponent(slug)}`;
};

// Build the private preview URL for an unpublished draft.
export const buildPreviewUrl = (token) => {
  if (typeof window === "undefined") return "";
  return `${window.location.origin}/?preview=${encodeURIComponent(token)}`;
};
